var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.display_all)?_c('div',{staticClass:"display-all"},[_c('div',{staticClass:"alert alert-danger pt-3"},[_c('h3',{staticClass:"text-center",domProps:{"innerHTML":_vm._s(_vm.$t('intern_qpay_error.fehler_titel'))}}),_c('div',{staticClass:"text-center",domProps:{"innerHTML":_vm._s(_vm.$t('intern_qpay_error.fehler_text'))}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }